import { render, staticRenderFns } from "./Useperformance.vue?vue&type=template&id=768067d7&"
import script from "./Useperformance.vue?vue&type=script&lang=js&"
export * from "./Useperformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports